import { cancelMarketingDataDialogRequest, MarketingDataDialogUseCase, selectMarketingDataDialog, useAppDispatch } from "@org-avp/avp-avengers-ui-shared-store";
import { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { MsgModalModel } from "../../hooks/use-message-modal-helper";
import { MessageModal } from "../msg-modal/MessageModal";

export interface MarketingDataDialogRequestHandlerDialogProps {
  useCase: MarketingDataDialogUseCase;
  onCancelParentDialog: () => void;
}

export const MarketingDataDialogRequestHandlerDialog: FC<MarketingDataDialogRequestHandlerDialogProps> = (
  { useCase, onCancelParentDialog },
) => {
  const { t } = useTranslation();

  const appDispatch = useAppDispatch();
  const dialogData = useSelector(selectMarketingDataDialog);

  const onClose = useCallback((ok: boolean) => {
    if (ok) onCancelParentDialog();
    else appDispatch(cancelMarketingDataDialogRequest());
  }, [appDispatch, onCancelParentDialog]);

  const isDialogVisible = useMemo(
    () => dialogData.active?.useCase === useCase && dialogData.requested,
    [dialogData, useCase],
  );

  const msgModalData: MsgModalModel = useMemo(
    () => ({
      type: "CONFIRMATION",
      title: t("marketingDataDialogs:discardChangesConfirm.title"),
      message: t("marketingDataDialogs:discardChangesConfirm.message"),
      okText: t("common:discardChanges"),
      cancelText: t("common:cancel"),
    }),
    [t],
  );

  return (
    <>
      {isDialogVisible && <MessageModal onClose={onClose} msgModalData={msgModalData}/>}
    </>
  );
};
